"use client"

// P-147 (SPEC-102 Task A — CRÍTICA): mount-gate del Toaster shadcn (radix).
//
// Análisis (estático + empírico, ver worklog Task 2-c):
//   1. `useToast()` (hooks/use-toast.ts) sincroniza con `memoryState`, un
//      estado A NIVEL DE MÓDULO. En SSR (render del build) siempre está
//      vacío; en el cliente, cualquier toast encolado antes de que termine
//      la hidratación (interceptores 401 del api-client, handlers de
//      red/SW — todos viven en el MISMO chunk compartido del root layout
//      que apuntaba el stack de QA) hace que el PRIMER render del cliente
//      renderice <Toast>... dentro de la región que el HTML del servidor
//      no tiene → React #418 "server rendered HTML didn't match the
//      client" en TODA ruta.
//   2. QA observó la región radix (DIV "Notifications (F8)") SOLO en el DOM
//      post-hydration — con el gate ese comportamiento pasa de "depende del
//      estado del módulo al hidratar" a "determinísticamente post-mount".
//
// El gate es aceptable (SPEC-102 §Task A paso 3/9): la región aparece
// post-mount igual que hoy, pero SIN ambigüedad de hidratación. Los toasts
// encolados pre-mount quedan en `memoryState` y se renderizan apenas el
// componente se monta (useState se inicializa con el memoryState vigente)
// → sin pérdida de feedback para las páginas admin (payouts, kyc,
// deposits, announcements — AUDIT-6-002).
import { useEffect, useState } from "react"
import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

export function Toaster() {
  const { toasts } = useToast()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  // Render nothing on the server AND on the hydration render — the radix
  // region + viewport only materialize after mount (post-hydration), so
  // module-level `memoryState` can never diverge from the (empty) SSR
  // output during hydration.
  if (!mounted) return null

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
